import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Operator } from '../models';
import {AccountService} from "./account.service";
import {Product} from "../models/product";
import {Category} from "../models/category";

@Injectable({ providedIn: 'root' })
export class ComponentTitleService {

    private pageTitle;
    private pageTitleParts: Array<string> = [];

    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    public clearTitle() {
        this.pageTitleParts = [];
        this.pageTitle = '';
    }

    public addPart(part: string) {
        this.pageTitleParts.push(part);
    }

    public setTitle(title: string) {
        this.pageTitle = title;
    }

    get getTitle() {
        return this.pageTitle;
    }

    public getTitleParts() {
        return this.pageTitleParts;
    }
}
